import { FunctionComponent } from "react";

import {
  dataAttribute,
  DataAttributes,
  IconButton,
  IContextualMenuItem,
  useTheme
} from "@bps/fluent-ui";

interface AddContextualMenuButtonProps {
  menuItems: IContextualMenuItem[];
  automationId: string;
}
export const AddContextualMenuButton: FunctionComponent<
  AddContextualMenuButtonProps
> = ({ menuItems, automationId }) => {
  const theme = useTheme();
  return (
    <IconButton
      iconProps={{ iconName: "Add" }}
      menuProps={{
        items: menuItems
      }}
      styles={{
        root: {
          height: 32,
          width: 32,
          minWidth: 32,
          alignSelf: "center",
          border: `1px solid ${theme.palette.neutralSecondaryAlt}`,
          borderRadius: 2,
          background: theme.semanticColors.buttonBackground,
          color: theme.palette.neutralSecondary
        },
        menuIcon: { display: "none" }
      }}
      {...dataAttribute(DataAttributes.Element, automationId)}
    />
  );
};
